// Route `api` cho thực thể `svcCatalog` (H-DT): `/v1/services` (TblService, không tiền) → thẻ Giới thiệu dịch vụ.
// DB chỉ có tên / phòng / cách giao / mốc hạn; mô tả, các bước, mã phí, ghi chú giá lấy từ dữ liệu mẫu cùng mã (không mất nội dung so với board).
import type { ApiRoute } from '@hana/data';
import type { SvcCatalog } from './catalogTypes';
import { SVC_CATALOG } from './catalogFixtures';

type Row = Record<string, unknown>;
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

export function svcCatalogFromApi(r: Row): SvcCatalog {
  const code = str(r.Title);
  const base = SVC_CATALOG.find((x) => x.code === code);
  return {
    id: code,
    code,
    name: str(r.ServiceName_VN) || base?.name || code,
    en: base?.en ?? '',
    dept: str(r.OwnerDept) || base?.dept || '',
    mode: str(r.DeliveryMode) || base?.mode || '',
    anchor: str(r.DeadlineAnchor) || base?.anchor || '',
    tone: base?.tone ?? 'gray',
    desc: base?.desc ?? '',
    long: base?.long ?? '',
    steps: base?.steps ?? [],
    codes: base?.codes ?? [],
    priceNote: base?.priceNote ?? '',
  };
}

export const svcCatalogApiRoute: ApiRoute<SvcCatalog> = {
  path: '/api/v1/services',
  query: () => ({ active: '1' }),
  parse: (json) => {
    const list = (json as { data?: unknown } | null)?.data;
    const rows = Array.isArray(list) ? (list as Row[]) : [];
    return { items: rows.filter((r) => str(r.Title)).map(svcCatalogFromApi) };
  },
};
